(function () {
  function getCheckedComplementaryVariants() {
    var boxes = document.querySelectorAll('.complementary-checkbox:checked');
    return Array.from(boxes).map(function (b) {
      return parseInt(b.value, 10);
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-type="add-to-cart-form"]');
    if (!form || !form.closest('.main-product-form')) return;

    var extraVariants = getCheckedComplementaryVariants();
    if (extraVariants.length === 0) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var mainVariantId = form.querySelector('input[name="id"]').value;
    var skipCartInput = form.querySelector('input[data-skip-cart="true"]');
var redirectUrl = skipCartInput ? '/checkout' : '/cart';
    var items = [{ id: mainVariantId, quantity: 1 }];
    extraVariants.forEach(function (id) {
      items.push({ id: id, quantity: 1 });
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) { return res.json(); })
.then(function () {
  window.location.href = redirectUrl;
})
      .catch(function (err) {
        console.error('Add to cart failed', err);
      });
  }, true);
})();
document.addEventListener('click', function (e) {
  var wrapper = e.target.closest('.complementary-checkbox-wrapper');
  if (!wrapper) return;

  e.preventDefault();
  e.stopPropagation();

  var checkbox = wrapper.querySelector('.complementary-checkbox');
  checkbox.checked = !checkbox.checked;
  wrapper.classList.toggle('is-selected', checkbox.checked);
}, true);